import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export const Section = ({ title, to, children, empty, testid }) => (
  <div className="mt-6" data-testid={testid}>
    <div className="flex items-center justify-between mb-3">
      <h3 className="font-display text-lg font-medium">{title}</h3>
      {to && (
        <Link to={to} className="text-xs text-[color:var(--text-secondary)] flex items-center gap-0.5">
          Visa alla <ChevronRight size={14} />
        </Link>
      )}
    </div>
    {empty ? (
      <div className="card-soft p-5 text-sm text-[color:var(--text-secondary)] text-center">
        {empty}
      </div>
    ) : (
      children
    )}
  </div>
);
